import { apiCall } from "../../services/api-service";

export const getIssueListApi = (params) =>
  apiCall("get", `issue?${params}`);

export const getVehicleDetailsApi = (id) =>
  apiCall("get", `get_vehicle_details/${id}`);

export const getIssueEditDetailsApi = (id) =>
  apiCall("get", `issue/edit/${id}`);

export const getAttachmentListApi = (id) =>
  apiCall("get", `issue/attachment/${id}`);

export const getRemoveAttachmentApi = (id) =>
  apiCall("get", `issue/remove_attachment/${id}`);

export const submitIssueAPI = (body) =>
  apiCall("post", "issue", body);

export const updateIssueAPI = (id, body) =>
  apiCall("put", `issue/${id}`, body);

export const getIssueViewDetailsApi = (id) =>
  apiCall("get", `issue/view/${id}`);

export const saveAttachmentApi = (id, body) =>
  apiCall("put", `issue/add_attachment/${id}`, body);
